module.exports = __webpack_public_path__ + "img/greenTick.681f0b9a.png";